import { type AxiosError } from "axios"
import { call, put } from "redux-saga/effects"
import { type PayloadAction } from "typesafe-actions"

import ChecklistAPI, { type PlateResponseData } from "../../../APIs/ChecklistAPI"
import { PlateDataFailure, PlateDataSuccess } from "./actions"
import { type OneFleetDevolucaoFormsTypes, type OneFleetDevolucaoPlateInfo } from "./types"

export type SearchPlateSagaPayload = {
  plate: string
  recaptchaToken: string
}

export function * searchPlate (action: PayloadAction<OneFleetDevolucaoFormsTypes, SearchPlateSagaPayload>): Generator {
  try {
    const {
      plate,
      recaptchaToken
    } = action.payload

    const plateData = (yield call(ChecklistAPI.getPlateInfo, plate, recaptchaToken)) as PlateResponseData

    const finalData: OneFleetDevolucaoPlateInfo["data"] = {
      carKm: plateData.Km_Atual,
      company: plateData.Razao_Social || plateData.Cliente,
      dealer: plateData.Concessionaria_Entrega,
      model: plateData.Modelo
    }
    yield put(PlateDataSuccess(finalData))
  } catch (err) {
    let errorMessage: string = "Ocorreu um erro, tente novamente mais tarde!"

    if ((err as AxiosError).isAxiosError) {
      errorMessage = (err as AxiosError<{ message: string }>).response?.data?.message ?? ""
    } else if (err instanceof Error) {
      errorMessage = err.message
    }

    yield put(PlateDataFailure(errorMessage))
  }
}
